import { type DetailState } from "./state";

export const initialState: DetailState = {
  detail: null,
  isPending: false,
  isRejected: false,
  errorMessage: "",
};
